import { styled } from '@/stitches.config';
import { Box } from '@common/components';

export const StyledContainer = styled(Box, {
  display: 'flex',
  height: '100%',
  background: 'url(/src/assets/background.svg) no-repeat',
  backgroundSize: 'cover',
  backgroundColor: '$white',
});

export const StyledContent = styled(Box, {
  margin: 'auto',
  width: '60%',
  maxWidth: '500px',
  minWidth: '200px',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
});

export const StyledActionsContainer = styled(Box, {
  display: 'inline-flex',
  width: '100%',
  padding: '$4 $0',
  alignContent: 'start',
});
